import { register } from '@shopify/theme-sections';
import Flickity from 'flickity';
import 'flickity-imagesloaded';

export default register('collection-page', {
  onLoad() {
    const drawerFiltersOpen = document.querySelector('[data-toggle-filters]');
    if (drawerFiltersOpen) {
      drawerFiltersOpen.addEventListener(
        'click',
        this.btnDrawerFiltersClickOpenHandler.bind(this)
      );
    }
    const drawerFiltersClose = document.querySelector(
      '.drawer-filters__close'
    );
    if (drawerFiltersClose) {
      drawerFiltersClose.addEventListener(
        'click',
        this.btnDrawerFiltersClickCloseHandler.bind(this)
      );
    }

    const drawerFiltersOverlay = document.querySelector(
      '[data-toggle-drawer-filters]'
    );
    if (drawerFiltersOverlay) {
      drawerFiltersOverlay.addEventListener(
        'click',
        this.btnDrawerFiltersClickCloseHandler.bind(this)
      );
    }

    const drawerSortOpen = document.querySelector('[data-toggle-sort]');
    if (drawerSortOpen) {
      drawerSortOpen.addEventListener(
        'click',
        this.btnDrawerSortClickOpenHandler.bind(this)
      );
    }
    const drawerSortClose = document.querySelector(
      '.drawer-sort__close'
    );
    if (drawerSortClose) {
      drawerSortClose.addEventListener(
        'click',
        this.btnDrawerSortClickCloseHandler.bind(this)
      );
    }

    const drawerSortOverlay = document.querySelector(
      '[data-toggle-drawer-sort]'
    );
    if (drawerSortOverlay) {
      drawerSortOverlay.addEventListener(
        'click',
        this.btnDrawerSortClickCloseHandler.bind(this)
      );
    }

    const thisSlider = document.querySelector(
      '#featured-products__slider--' + this.id
    );

    if (thisSlider) {
      var slider = new Flickity(thisSlider, {
        freeScroll: false,
        contain: true,
        prevNextButtons: false,
        pageDots: false,
        imagesLoaded: true,
        setGallerySize: true,
        cellAlign: 'left',
        watchCSS: true,
        wrapAround: false,
      });

      Flickity.prototype._createResizeClass = function() {
        this.element.classList.add('flickity-resize');
      };

      Flickity.createMethods.push('_createResizeClass');

      var resize = Flickity.prototype.resize;
      Flickity.prototype.resize = function() {
        this.element.classList.remove('flickity-resize');
        resize.call(this);
        this.element.classList.add('flickity-resize');
      };
    }
  },

  btnDrawerFiltersClickOpenHandler(evt) {
    evt.preventDefault();
    document.body.classList.add('drawer-filters-is-expanded');
  },

  btnDrawerFiltersClickCloseHandler(evt) {
    evt.preventDefault();
    document.body.classList.remove('drawer-filters-is-expanded');
  },

  btnDrawerSortClickOpenHandler(evt) {
    evt.preventDefault();
    document.body.classList.add('drawer-sort-is-expanded');
  },

  btnDrawerSortClickCloseHandler(evt) {
    evt.preventDefault();
    document.body.classList.remove('drawer-sort-is-expanded');
  },
});
